export default "__VITE_ASSET__BTn4heGY__"